export const firebaseConfig = {
    apiKey: 'AIzaSyDqsKWzobKEd7YlBOp4QmsZU22_TRcr_jc',
    authDomain: 'lexhero-48c63.firebaseapp.com',
    projectId: 'lexhero-48c63',
    storageBucket: 'lexhero-48c63.firebasestorage.app',
    messagingSenderId: '517436866000',
    appId: '1:517436866000:web:b76a362a1fdee3f8c1cdd5',
    measurementId: 'G-CSZNTWPYTJ',
} as const;

export const VAPID_PUBLIC_KEY =
    'BAS0QvIE-StrFfuY_5tSeLIpsD9_kwVQ16j1EZe7xphj1cNSX2ncxaB5rHJifv5kYvZbF5M0Cgc8QZ4M-MQnXHo' as const;
